import { render, staticRenderFns } from "./RestaurantsCarouselSectionModule.vue?vue&type=template&id=4bfa4f8b&"
import script from "./RestaurantsCarouselSectionModule.vue?vue&type=script&lang=js&"
export * from "./RestaurantsCarouselSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports